import http from '@/http';
import { getBrowser } from '@/tools';
import store from '@/store'
//import router from '@/router';
// import Vue from 'vue';

const login = ({ commit }, user) => {
  return new Promise((resolve, reject) => {
    let headers = {
      sistema: "Portal",
      plataforma: getBrowser()[0],
      versao: getBrowser()[1],
      ip: store.state.ip,
    }

    if (window.latLng) {
      headers.lat = window.latLng.lat;
      headers.lng = window.latLng.lng;
    }

    http.post('api/auth/login', {
      email: user.email,
      cpf: user.cpf,
      password: user.password,
    }, {
      headers
    }).then(response => {
      commit('DEFINIR_USUARIO_LOGADO', {
        access_token: response.data.access_token,
        user: response.data.user,
        me: response.data.me
      })
      commit('RESET_STATE');
      http.get("api/portalmenu").then((responseroute) => {
        let menuItems = processData(responseroute.data);
        // if (menuItems.length <= 0) {
        //   commit("DESLOGAR_USUARIO");
        // }
        commit("CRIA_MENU_ITEM", menuItems);
        resolve(response.data)
      });
    }).catch(err => {
      reject(err)
    })
  })
}

const logout = ({ commit }) => {
  return new Promise((resolve, reject) => {
    http.post('api/auth/logout')
      .then(() => {
        commit('DESLOGAR_USUARIO')
        resolve();
      }).catch(() => {
        commit('DESLOGAR_USUARIO')
        reject();
      })
  });
}

function processData(data) {
  let objetoMenu = [];
  let itemMenu = null;

  if (data.length <= 0) {
    alert("Perfil do usuário sem módulos no sistema, entre em contato com a Unicampo!");
  }

  data.forEach((route) => {
    if (typeof route.subItems !== "undefined") {

      itemMenu = processData(route.subItems);

      objetoMenu.push({
        id: route.id,
        label: route.label,
        subItems: itemMenu,
        isTitle: route.isTitle,
        icon: route.icon,
      });
    } else {
      objetoMenu.push({
        id: route.id,
        label: route.label,
        link: route.link,
        parentId: route.parentId,
        isTitle: route.isTitle,
        icon: route.icon,
      });
    }
  });

  return objetoMenu;
}

const filtroTomador = ({ commit }, filtro) => {
  return new Promise((resolve, reject) => {
    if (filtro) {
      resolve(filtro);
      return;
    }
    http.get("api/tomador/filtrarProjetos")
      .then((response) => {
        commit('FILTRO_TOMADOR', response.data);
        resolve(response.data);
      }).catch((err) => {
        reject(err);
      })
  });
}
export {
  login,
  logout,
  filtroTomador
}
